import { render, staticRenderFns } from "./RecordBook.vue?vue&type=template&id=e751f4de&scoped=true&"
import script from "./RecordBook.vue?vue&type=script&lang=js&"
export * from "./RecordBook.vue?vue&type=script&lang=js&"
import style0 from "./RecordBook.vue?vue&type=style&index=0&id=e751f4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e751f4de",
  null
  
)

export default component.exports